import { Alert, Loader, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useDsCoreOAuth } from "../../hooks/useDsCoreOAuth";
import { notifications } from "@mantine/notifications";

export const DsCoreCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  const {
    state: savedState,
    codeVerifier,
    regenerateDsCoreTokens,
    resetFlow,
  } = useDsCoreOAuth();
  const navigate = useNavigate();

  // The code is single-use: StrictMode runs effects twice in development,
  // and a second exchange would fail after the first one succeeded
  const hasExchanged = useRef(false);

  useEffect(() => {
    if (
      hasExchanged.current ||
      !code ||
      !state ||
      !codeVerifier ||
      !savedState ||
      state !== savedState
    ) {
      return;
    }
    hasExchanged.current = true;

    void regenerateDsCoreTokens({
      code,
      codeVerifier,
    })
      .then(() => {
        notifications.show({
          title: "Success",
          message: "DS Core tokens have been regenerated!",
          color: "green",
        });
      })
      .catch(err => {
        notifications.show({
          title: "Error",
          message: `Failed to regenerate DS Core tokens: ${err.message}`,
          color: "red",
        });
      })
      .finally(() => {
        resetFlow();
        navigate("/settings");
      });
  }, [code, state, savedState, codeVerifier]);

  if (!code || !state || !codeVerifier || !savedState || state !== savedState) {
    return (
      <Alert
        variant="light"
        color="red"
        title="An error occured"
        icon={<IconInfoCircle />}
      >
        <Text>{"Token generation failed."}</Text>
      </Alert>
    );
  }

  return (
    <Stack align="center" justify="center" style={{ height: "100vh" }}>
      <Loader size="xl" variant="dots" />
      <Text>Generating token...</Text>
    </Stack>
  );
};
